import { Routes, RouterModule } from "@angular/router";

import { StaffComponent, ViewStaffComponent, ScanHistoryComponent } from "./index";
import { StaffDigitalIdRegistrationComponent } from "./staff-digital-id-registration/staff-digital-id-registration.component";
import { AuthguardService } from "../master/services";
import { StaffNotificationsComponent } from "./staff-notifications/staff-notifications.component";

export const StaffRoutes: Routes = [
	{ path: "", redirectTo: "/staff/viewstaff", pathMatch: "full" },
	{
		path: "viewstaff",
		data: { title: "View Staff" },
		component: ViewStaffComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "scan",
		data: { title: "Staff Scan History" },
		component: ScanHistoryComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "didregistration",
		data: { title: "Digital ID Registration", HideSelector: true },
		component: StaffDigitalIdRegistrationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "notifystaff",
		data: { title: "Staff Notifications" },
		component: StaffNotificationsComponent,
		canActivate: [AuthguardService],
	},
];
